import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private msalService:MsalService) { }

  getRoles():any[]{
    const rolesOfService = this.msalService.instance.getActiveAccount()?.idTokenClaims?.roles || [];
    return rolesOfService || [];
  }

  hasRole(role:string):boolean{
    return this.getRoles().includes(role);
  }

  /**
   * Super administradores habilitados para editar o eliminar inscripciones a eventos:
   * el administrador de eventos (SID_EVENT_ADMIN) y el administrador global (SID_ADMINISTRATOR).
   */
  isEventSuperAdmin():boolean{
    return (
      this.hasRole(environment.roles.adminEventosRole) ||
      this.hasRole(environment.roles.adminRole)
    );
  }

  /** Nombre del usuario autenticado, usado para la auditoría de los cambios */
  getUserName():string{
    const account = this.msalService.instance.getActiveAccount();
    return (account?.idTokenClaims?.['name'] as string) || account?.username || 'Administrador SID';
  }
}
